import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Home, Products, NotFound } from "./pages";

const App = () => {
  return (
    <div className="max-w-screen">
      <ToastContainer position="bottom-left text-center z-[100]" />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Redirect /products to home page */}
        <Route path="/products" element={<Navigate to="/" replace />} />
        {/* Added accept category parameter in route */}
        <Route path="/products/:category" element={<Products />} />
        {/* 404 Not Found route - must be last */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default App;
